module.exports = __webpack_public_path__ + "static/media/48357658_2308812849193893_6356078193899732992_o.6dd5618c.jpg";